import React from "react";

const MARK_SRC = "/brand/mark-160.webp";
const LOCKUP_SRC = "/brand/lockup-120.webp";
const LOCKUP_RATIO = 397 / 120;

export function LogoMark({ size = 40, className = "" }) {
  return (
    <img src={MARK_SRC} width={size} height={size} alt="Bhavishyavani"
         className={`object-contain ${className}`} decoding="async" data-testid="logo-mark" />
  );
}

/** Compact lockup: official logo image (for nav / footer) */
export function LogoLockup({ size = 40 }) {
  const h = Math.round(size * 1.2);
  const mh = Math.round(h * 0.8);
  return (
    <>
      <img src={LOCKUP_SRC} alt="Bhavishyavani — AI Future Insights" fetchpriority="high"
           width={Math.round(mh * LOCKUP_RATIO)} height={mh}
           className="sm:hidden object-contain" data-testid="logo-lockup-mobile" />
      <img src={LOCKUP_SRC} alt="Bhavishyavani — AI Future Insights" fetchpriority="high"
           width={Math.round(h * LOCKUP_RATIO)} height={h}
           className="hidden sm:block object-contain" data-testid="logo-lockup" />
    </>
  );
}

/** Stacked lockup — big centerpiece */
export function LogoFull({ className = "" }) {
  return (
    <img src={LOCKUP_SRC} alt="Bhavishyavani — AI Future Insights" width={397} height={120}
         className={`object-contain ${className}`} />
  );
}

export default LogoLockup;
